module.exports = __webpack_public_path__ + "img/icon-home-ev-01.4e61972e.png";